import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import { downloads } from '../../utils/calsoft-validators';
import { Constant } from 'src/app/constant/constant';
import { ProductService } from 'src/app/services/product.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { FieldConfig } from '../field-interface';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-multiple-images',
  templateUrl: './multiple-images.component.html',
  styleUrls: ['./multiple-images.component.scss']
})
export class MultipleImagesComponent implements OnDestroy {

  sanitizedUrl: string = '';

  url = '';


  field: FieldConfig['eavAttribute'];
  group: UntypedFormGroup;
  text: string;
  public serverPath = environment.commonImageApi + 'gallery/';
  value: any;

  imagename: string;

  constructor(
    private snackBar: MatSnackBar,
    private productService: ProductService, private router: Router) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit(): void {

    this.text = "Save"
    this.value= this.group.value[this.field.attributeCode];

    if(this.value!=null){
      this.imageList=JSON.parse(this.value);
    }


  }


  imageVisible: boolean = true;
  imageDelete: boolean;
  imagesToRemoved: any = [];
 
  deleteImage(imageName:any,index) {
    this.imageVisible = false;
    this.imageDelete = true;
    let smallImage = "/gallery/" + imageName;
    this.imagesToRemoved.push(smallImage);

    this.productService.deleteImage(this.imagesToRemoved).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom'
          , duration: 500 });
          this.text = "Save"
          this.imageVisible = false;
          this.imageDelete = false;

          this.imageList.splice(index, 1);
          this.group.value[this.field.attributeCode]= JSON.stringify(this.imageList);
          this.group.patchValue(this.group.value)
          this.value= this.group.value[this.field.attributeCode];
          
        }
        else {
          this.imageVisible = true;
          this.imageDelete = false;
          this.group.value[this.field.attributeCode]='';
          this.group.patchValue(this.group.value)
          this.text = "Save"
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => {
        this.imageVisible = true;
      });

  }

  getResulNew(event) {
    this.imageVisible = true;
    this.group.value[this.field.attributeCode]=event.productEntityMediaGallery[0].fileName
    this.group.patchValue(this.group.value)
    this.value= this.group.value[this.field.attributeCode];
  }


  imageList: Array<{ value: string; imageName: string }> = [];
  

  getResult(event: any) {
    this.imageVisible = true;
    if(this.imageList==null){
      this.imageList=[];
    }

    if (Array.isArray(event.productEntityMediaGallery)) {
      event.productEntityMediaGallery.forEach(element => {
        const object = {
          value: '',
          imageName: element['fileName'],
        };
        this.imageList.push(object);
      });
      this.group.value[this.field.attributeCode]= JSON.stringify(this.imageList);
    this.group.patchValue(this.group.value)
    this.value= this.group.value[this.field.attributeCode];
    } else {
      console.error('productEntityMediaGallery is not an array');
    }
  }

  cancelUpload() {
    this.imageVisible = true;
  }

  logo() {
    this.imageVisible = false;
  }

  download() {
    let smallImage = "/gallery/" + this.group.value[this.field.attributeCode];
    this.productService.downloadPdf(smallImage).subscribe(
      data => {
        downloads(data);
      })
  }


  removeImageOption(index: number): void {
    if (index > -1 && index < this.imageList.length) {
      this.imageList.splice(index, 1);
    }
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}

